
import React from 'react';

interface FooterProps {
  onShowPrivacyPolicy?: () => void;
  onShowTermsOfService?: () => void;
  onShowAboutUs?: () => void;
}

const Footer: React.FC<FooterProps> = ({ onShowPrivacyPolicy, onShowTermsOfService, onShowAboutUs }) => {
  const LinkedInIcon = () => (
    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
    </svg>
  );

  return (
    <footer className="w-full bg-primary-200 py-6 sm:py-8 overflow-x-hidden">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 md:px-8">
        {/* Desktop Footer */}
        <div className="hidden md:flex justify-between items-center text-sm">
          <div className="flex items-center gap-4">
            <a 
              href="https://www.linkedin.com/company/university-tech" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-black hover:text-primary-600 transition-colors"
            >
              <LinkedInIcon />
              Follow us on LinkedIn
            </a>
          </div>
          <div className="flex items-center gap-2 text-black">
            <button 
               onClick={onShowAboutUs}
               className="bg-transparent border-none cursor-pointer font-grotesk text-sm hover:text-primary-600 transition-colors">
              About Us
            </button>
            <span>|</span>
            <button 
               onClick={onShowTermsOfService}
               className="bg-transparent border-none cursor-pointer font-grotesk text-sm hover:text-primary-600 transition-colors">
              Terms of service
            </button>
            <span>|</span>
            <button 
               onClick={onShowPrivacyPolicy}
               className="bg-transparent border-none cursor-pointer font-grotesk text-sm hover:text-primary-600 transition-colors">
              Privacy Policy
            </button>
          </div>
        </div>

        {/* Mobile Footer */}
        <div className="md:hidden text-sm">
          <div className="flex flex-col items-center space-y-3">
            <button 
              onClick={onShowAboutUs}
              className="text-black hover:text-primary-600 transition-colors font-grotesk"
            >
              About Us
            </button>
            <a 
              href="https://www.linkedin.com/company/university-tech" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-black hover:text-primary-600 transition-colors"
            >
              <LinkedInIcon />
              Follow us on LinkedIn
            </a>
            <button 
              onClick={onShowTermsOfService}
              className="text-black hover:text-primary-600 transition-colors font-grotesk"
            >
              Terms of service
            </button>
            <button 
              onClick={onShowPrivacyPolicy}
              className="text-black hover:text-primary-600 transition-colors font-grotesk"
            >
              Privacy Policy
            </button>
          </div>
        </div>

        <div className="mt-6 pt-6 border-t border-primary-300 text-center text-xs text-black">
          Copyright © 2024-2025 Paragise Private Limited. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;